module.exports = __webpack_public_path__ + "img/bitcoin.f92890de.svg";